var call = Function.prototype.call;

module.exports = call.bind ? call.bind(call) : function () {
  return call.apply(call, arguments);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/function-call.js
// module id = 11
// module chunks = 0